<br>
<h1 class="titulo">Seguro de Gastos Médicos Menores</h1>
<nz-spin [nzSpinning]="loading" nzTip="Cargando..." class="loading-spinner">
<div class="boton-añadir-container">
  <button
    nz-button
    nzType="primary"
    class="excel-button boton-añadir"
    *ngIf="NoAcceso"
    (click)="AddSolicitud()"
  >
    <i nz-icon nzType="plus" nzTheme="outline"></i>
    Añadir Solicitud
  </button>
</div>
<div class="tabla-principal">
  <div class="tabla-header-container">
    <div class="tabla-header-left">
      <span class="registros-label"
        >Registros: <strong>{{ solicitudes.length }}</strong></span
      >
    </div>
    <div class="tabla-header-right" *ngIf="this.user?.esAdmin || this.user?.esRRHH">
      <nz-switch
          id="my_info"
          [(ngModel)]="mi_info"
          (ngModelChange)="obtenerData()"
          nzCheckedChildren="Mi información"
          nzUnCheckedChildren="Vista general"
          class="red-switch"
          style="margin-right: 50px;">
        </nz-switch>
      <button nz-button nzType="primary" class="excel-button" (click)="descargarExcel()" [disabled]="generarExcel">
        <i nz-icon nzType="file-excel" nzTheme="outline"></i>
        Generar Excel
      </button>
    </div>
  </div>


        <div class="search-container search-input-full">
        <nz-input-group nzSuffixIcon="search" class="">
          <input 
            type="text" 
            nz-input 
            placeholder="Buscar por ID o Nombre.." 
            [(ngModel)]="searchText"
            (ngModelChange)="onSearchChange($event)"
          />
        </nz-input-group>
      </div>
      
  <div class="table-scroll-container">
    <nz-table
      #basicTable
      [nzData]="solicitudes || []"
      class="tabla-colaboradores tabla-compacta"
    >
    <thead>
      <tr>
        <ng-container *ngIf="user?.esColaborador; else TemplateAdmin">
        <th class="col-acciones bold"></th>
        <th class="col-fecha-solicitud-colaborador bold">Fecha Solicitud</th>
        <th class="col-estatus-colaborador bold">Estatus</th>
        <th class="col-montos-colaborador bold">Monto Autorizado</th>
        <th class="col-fecha-solicitud-colaborador bold">Fecha de Aprobación</th>
        <th class="col-comentarios bold">Comentarios</th>
        </ng-container>
        <ng-template #TemplateAdmin>
        <th class="col-acciones bold"></th>
        <th class="col-numero-empleado bold">Numero de Empleado</th>
        <th class="col-fecha-solicitud bold">Fecha Solicitud</th>
        <th class="col-estatus bold">Estatus</th>
        <th class="col-colaborador bold">Colaborador</th>
        <th class="col-monto bold">Monto Autorizado</th>
        <th class="col-fecha-solicitud bold">Fecha de Aprobación</th>
        <th class="col-comentarios bold">Observaciones</th>
        </ng-template>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of basicTable.data">
        <td class="col-acciones">
          <div class="center-container">
            <!-- <i
              nz-icon
              nzType="eye"
              nzTheme="outline"
              (click)="onAccionClick(item)"
              style="cursor: pointer; color: #000000; margin-right: 8px"
              title="Ver detalles"
            ></i> -->
            <img
                  src="assets/icon/detail-sgmm.svg"
                  class="icono-sgmm"
                  style="cursor: pointer;"
                  alt="icono sgmm"
                  (click)="onAccionClick(item)"
                />
            <!-- <i
              nz-icon
              nzType="edit"
              nzTheme="outline"
              (click)="onEditClick(item)"
              style="cursor: pointer; color: #52c41a"
              title="Editar"
            ></i> -->
          </div>
        </td>
        <td class="col-numero-empleado" *ngIf="!user?.esColaborador">
          {{ item?.colaboradorNumeroEmpleado }}
        </td>
        <td class="col-fecha-solicitud">
          {{ item.fechaSolicitud | date : "dd/MM/yyyy" }}
        </td>
        <td class="col-estatus">
          <div 
            class="estatus-container"
            [class.texto-negro]="shouldUseBlackText(item.estatusNombre)"
            [style.background-color]="getEstatusColor( item.estatusNombre)"
          >
            <img 
              [src]="getEstatusIcon( item.estatusNombre)" 
              class="estatus-icon"
              alt="Estatus icon"
            />
            <span class="estatus-text">{{ item.estatusNombre }}</span>
          </div>
        </td>
        <td class="col-colaborador" *ngIf="!user?.esColaborador">
          <div class="colaborador-info">
              {{ item.colaboradorNombres }} {{ item.colaboradorApellidos }}
          </div>
        </td>
        <td class="col-monto">
          <span
            class="monto-valor"
            [ngClass]="{
              'monto-cero': item.montoTotalAutorizado === 0,
              'monto-null': item.montoTotalAutorizado == null
            }"
          >
            <ng-container
              *ngIf="item.montoTotalAutorizado == null; else montoValido"
            >
            <span class="monto-placeholder">N/A</span>
            </ng-container>
            <ng-template #montoValido>
              <ng-container
                *ngIf="item.montoTotalAutorizado === 0; else montoNormal"
              >
                <span class="monto-cero-text">Sin autorizar</span>
              </ng-container>
              <ng-template #montoNormal>
                {{
                  item.montoTotalAutorizado
                    | currency : "MXN" : "symbol" : "1.2-2"
                }}
              </ng-template>
            </ng-template>
          </span>
        </td>
        <td class="col-fecha-solicitud">
          <ng-container *ngIf="item.fechaPago; else noFecha">
            {{ item.fechaPago | date : "dd/MM/yyyy" }}
          </ng-container>
          <ng-template #noFecha>
            <span class="monto-null">N/A</span>
          </ng-template>
        </td>
        <td class="col-comentarios">
            {{ (item?.comentariosAutorizacion | slice : 0 : 50) ?? "N/A" }}
            <span *ngIf="(item.comentariosAutorizacion?.length || 0) > 50"
              >...</span
            >
        </td>
      </tr>
    </tbody>
  </nz-table>
  </div>
</div>
</nz-spin>
